import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = {
  class: "h-100",
  id: "heatmap-tab"
}
const _hoisted_3 = { class: "container-fluid h-100 d-flex flex-column" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = { class: "col-12 col-md-6" }
const _hoisted_7 = {
  id: "heatmap",
  class: "mt-2"
}
const _hoisted_8 = {
  class: "h-100",
  id: "tasks-tab"
}
const _hoisted_9 = { class: "h-100 d-flex flex-column align-items-start" }
const _hoisted_10 = { class: "align-items-baseline d-flex w-100" }
const _hoisted_11 = {
  key: 0,
  class: "flex-grow-1"
}
const _hoisted_12 = { class: "w-100 list-group overflow-auto mt-3" }
const _hoisted_13 = { class: "list-group-item list-group-item-action" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "m-0" }
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = { class: "ml-2 badge badge-secondary" }
const _hoisted_19 = {
  key: 0,
  class: "ml-2 badge badge-pill badge-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MxGraphChart = _resolveComponent("MxGraphChart")!
  const _component_ProgressIndicator = _resolveComponent("ProgressIndicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_select, {
              class: "filter-dropdown mb-2",
              multiple: "",
              closeOnSelect: false,
              placeholder: "Select projects...",
              label: "name",
              onInput: _ctx.updateGraphWithDelay,
              modelValue: _ctx.selectedProjects,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProjects) = $event)),
              options: _ctx.projects
            }, null, 8, ["onInput", "modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_select, {
              class: "filter-dropdown mb-2",
              multiple: "",
              closeOnSelect: false,
              placeholder: "Select resources...",
              label: "name",
              onInput: _ctx.updateGraphWithDelay,
              modelValue: _ctx.selectedResources,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedResources) = $event)),
              options: _ctx.resources
            }, null, 8, ["onInput", "modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_MxGraphChart, {
            ref: "heatmap",
            graphId: "heatmap",
            initGraph: _ctx.initGraph
          }, null, 8, ["initGraph"]),
          _createVNode(_component_ProgressIndicator, {
            ref: "progress",
            id: "heatmap-glasspane",
            type: "spinner"
          }, null, 512)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.resource)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_11, _toDisplayString(_ctx.resource.name), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-attention",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showHeatmap && _ctx.showHeatmap(...args)))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1),
            _createTextVNode(" Chart ", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h5", _hoisted_16, _toDisplayString(task.name), 1)
                  ]),
                  _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.getTimestampString(task.startTs)) + " — " + _toDisplayString(_ctx.getTimestampString(task.endTs)), 1)
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(task.projectName), 1),
                (task.maxSumLoad > 100)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(task.load), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 256))
        ])
      ])
    ])
  ]))
}